module.exports = __webpack_public_path__ + "img/instagram.53bb337c.svg";